import { render, staticRenderFns } from "./vehicleinspectionform.html?vue&type=template&id=5c6f852a&scoped=true&external"
import script from "./vehicleinspectionform.vue?vue&type=script&lang=js"
export * from "./vehicleinspectionform.vue?vue&type=script&lang=js"
import style0 from "./vehicleinspectionform.vue?vue&type=style&index=0&id=5c6f852a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f852a",
  null
  
)

export default component.exports